import React from "react";
import Logo from "../assets/img/Asiatech_logo_farsi.png";

import FormModal from "./FormModal";
import { useProjectContext } from "../context/ProjectProvider";
import { useEffect, useState, useRef } from "react";
import Grow from "@mui/material/Grow";
import Swal from "sweetalert2";
import axios from "axios";
import Loading from "./Loading";
const Home = () => {
  const formSectionRef = useRef();
  const { form, FormClose, FormShow } = useProjectContext();
  const [data, setData] = useState({});

  const openModal = () => {
    FormShow();
  };

  const deg = 6;
  setInterval(() => {
    let day = new Date();
    let hh = day.getHours() * 30;
    let mm = day.getMinutes() * deg;
    let ss = day.getSeconds() * deg;
    document.querySelector("#hr").style.transform = `rotateZ(${
      hh + mm / 12
    }deg)`;
    document.querySelector("#mn").style.transform = `rotateZ(${mm}deg)`;
    document.querySelector("#sc").style.transform = `rotateZ(${ss}deg)`;
  });

  const getAllData = async () => {
    setLoading(true);
    try {
      const rawResponse = await fetch(
        "https://asiatech.bamdadealborz.ir/admin/SiteInfos/API/_getData?token=test",
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
            token: "test",
          }),
          body: JSON.stringify({
            token: "test",
          }),
        }
      );
      const content = await rawResponse.json();

      if (content.isDone) {
        // console.log(content)
        setLoading(false);
        setData(content.data);
      }
    } catch (error) {
      // console.log(error)
    }
  };

  const validateMobilephone = (input) => {
    let mobile = /^09(1[0-9]|3[0-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}$/;
    if (mobile.test(input)) {
      setMobileRequire(false);
      return input;
    } else {
      setMobileRequire(true);
      return false;
    }
  };
  const validateTelphone = (input) => {
    let tel = /^0[0-9]{2,}[0-9]{7,}$/;
    if (tel.test(input)) {
      setTelRequire(false);
      return input;
    } else {
      setTelRequire(true);
      return false;
    }
  };

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [tel, setTel] = useState("");
  const [loading, setLoading] = useState(false);

  const [nameReqire, setNameRequire] = useState(false);
  const [mobileReqire, setMobileRequire] = useState(false);
  const [telReqire, setTelRequire] = useState(false);

  const handleNameChange = (e) => {
    setName(e.target.value);
    if (e.target.value.length >= 4) {
      setNameRequire(false);
    }
  };
  const handleMobileChange = (e) => {
    setMobile(e.target.value);
    validateMobilephone(e.target.value);
    if (validateMobilephone(e.target.value) === false) return;
  };
  const handleTelChange = (e) => {
    setTel(e.target.value);
    validateTelphone(e.target.value);
    if (validateTelphone(e.target.value) === false) return;
  };

  const sendData = (e) => {
    e.preventDefault();
    if (name === "" || name.length < 4) {
      setNameRequire(true);
      return;
    }
    validateMobilephone(mobile);
    if (validateMobilephone(mobile) === false) return;

    validateTelphone(tel);
    if (validateTelphone(tel) === false) return;
    setLoading(true);
    axios
      .post(
        "https://asiatech.bamdadealborz.ir/admin/Orders/API/_submitOrder?token=test",
        {
          name: name,
          mobile: mobile,
          tel: tel,
        },
        {
          headers: {
            token: "test",
          },
        }
      )
      .then((response) => {
        if (response.data.isDone) {
          setLoading(false);
          Swal.fire({
            type: "success",
            text: ".منتظر تماس همکاران ما باشید , باتشکر",
          });
          FormClose();
        } else {
          Swal.fire({
            type: "error",
            text: "دوباره تلاش کنید",
            confirmButtonText: "فهمیدم",
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div style={{ textAlign: "center", margin: "20px 20px" }}>
      <div className="clock">
        <div className="hour">
          <div className="hr" id="hr"></div>
        </div>
        <div className="min">
          <div className="mn" id="mn"></div>
        </div>
        <div className="sec">
          <div className="sc" id="sc"></div>
        </div>
      </div>
      <img src={Logo} className="logo" />
      <h3 className="title">ارائه دهنده اینترنت پرسرعت در سطح کشور</h3>

      <div
        className="txtWidth mx-auto "
        style={{
          textAlign: "right",
          width: "60%",
          direction: "rtl",
        }}
      >
        <Grow in={!loading} timeout={200} style={{ transformOrigin: "0 0 0" }}>
          <p className="txt" style={{ height: "auto" }}>
            {data && data.text}
          </p>
        </Grow>
      </div>
      <Grow in={!loading} timeout={800} style={{ transformOrigin: "0 0 0" }}>
        <div
          className="row mb-3 mx-auto divRow"
          style={{ justifyContent: "center", width: "100%" }}
        >
          <>
            <div
              onClick={() =>
                formSectionRef.current.scrollIntoView({ behavior: "smooth" })
              }
              className="col-lg-3 col-10 box d-flex px-0 m-2"
              style={{
                cursor: "pointer",
              }}
            >
              <img
                src={data.firstImage}
                style={{
                  width: "100%",
                  borderRadius: "0 10px 10px 0",
                  objectFit: "contain",
                }}
              />
            </div>
            <div
              onClick={() =>
                formSectionRef.current.scrollIntoView({ behavior: "smooth" })
              }
              className="col-lg-3 col-10 box d-flex px-0 m-2"
              style={{
                cursor: "pointer",
              }}
            >
              <img
                src={data.SecondImage}
                style={{
                  width: "100%",
                  borderRadius: "0 10px 10px 0",
                  objectFit: "contain",
                }}
              />
            </div>
            <div
              onClick={() =>
                formSectionRef.current.scrollIntoView({ behavior: "smooth" })
              }
              className="col-lg-3 col-10 box d-flex px-0 m-2"
              style={{
                cursor: "pointer",
              }}
            >
              <img
                src={data.ThirdImage}
                style={{
                  width: "100%",
                  borderRadius: "0 10px 10px 0",
                  objectFit: "contain",
                }}
              />
            </div>
          </>
        </div>
      </Grow>
      <div
        ref={formSectionRef}
        className="row "
        style={{ justifyContent: "center" }}
      >
        <div
          className=" col-lg-8 col-md-8 col-sm-8 col-12"
          style={{
            justifyContent: "center",
            background: "white",
            padding: "10px",
            borderRadius: "15px",
          }}
        >
          <form className="formRegister" id="Form">
            <div>
              <input
                className="my-2"
                placeholder="نام و نام خانوادگی"
                onChange={handleNameChange}
                value={name}
                style={
                  !nameReqire
                    ? {
                        textAlign: "right",
                        padding: "10px 15px",
                        borderRadius: "5px",
                        border: "1px solid #8d8d8d",
                        outline: "none",
                        fontSize: "15px",
                        width: "90%",
                      }
                    : {
                        textAlign: "right",
                        padding: "10px 15px",
                        borderRadius: "5px",

                        outline: "none",
                        fontSize: "15px",
                        width: "90%",

                        border: "1px solid #dc3545",
                      }
                }
              />

              {nameReqire ? (
                <Grow
                  in={nameReqire}
                  timeout={500}
                  style={{ transformOrigin: "0 0 0" }}
                >
                  <h5
                    className="mt-2"
                    style={{
                      color: "#dc3545",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    لطفا نام خود را وارد کنید
                  </h5>
                </Grow>
              ) : null}
            </div>

            <div>
              <input
                className="my-2"
                required
                pattern="[0-9]{5}[-][0-9]{7}[-][0-9]{1}"
                type="text"
                title="Ten digits code"
                maxLength={11}
                style={
                  !mobileReqire
                    ? {
                        textAlign: "right",
                        padding: "10px 15px",
                        borderRadius: "5px",
                        border: "1px solid #8d8d8d",
                        outline: "none",
                        fontSize: "15px",
                        width: "90%",
                      }
                    : {
                        textAlign: "right",
                        padding: "10px 15px",
                        borderRadius: "5px",
                        outline: "none",
                        fontSize: "15px",
                        width: "90%",

                        border: "1px solid #dc3545",
                      }
                }
                onChange={handleMobileChange}
                value={mobile}
                placeholder="شماره همراه"
              />
              {mobileReqire ? (
                <Grow
                  in={mobileReqire}
                  timeout={500}
                  style={{ transformOrigin: "0 0 0" }}
                >
                  <h5
                    className="mt-2"
                    style={{
                      color: "#dc3545",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    لطفا شماره تماس خود را به طور صحیح وارد کنید
                  </h5>
                </Grow>
              ) : null}
            </div>

            <div>
              <input
                className="my-2"
                onChange={handleTelChange}
                value={tel}
                maxLength={11}
                style={
                  !telReqire
                    ? {
                        textAlign: "right",
                        padding: "10px 15px",
                        borderRadius: "5px",
                        border: "1px solid #8d8d8d",
                        outline: "none",
                        fontSize: "15px",
                        width: "90%",
                      }
                    : {
                        textAlign: "right",
                        padding: "10px 15px",
                        borderRadius: "5px",
                        outline: "none",
                        fontSize: "15px",
                        width: "90%",

                        border: "1px solid #dc3545",
                      }
                }
                placeholder="شماره ثابت (لطفا کد شهر خود را وارد کنید)"
              />
              {telReqire ? (
                <Grow
                  in={telReqire}
                  timeout={500}
                  style={{ transformOrigin: "0 0 0" }}
                >
                  <h5
                    className="mt-2"
                    style={{
                      color: "#dc3545",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    لطفا شماره تماس خود را به طور صحیح وارد کنید(با پیش شماره)
                  </h5>
                </Grow>
              ) : null}
            </div>

            <button className="sendBtn" onClick={sendData}>
              {loading ? <Loading /> : "ثبت سفارش"}
            </button>
          </form>
        </div>
      </div>

      {form ? <FormModal /> : null}
    </div>
  );
};

export default Home;
